<template>
	<vxe-modal :loading="loading" v-model="modal" width="800" height="500" @show="show" @hdie="hide" :title="title"
		destroy-on-close :showFooter="true">
		<template #default>
			<vxe-table :checkbox-config="{trigger: 'row'}" ref="wlnfillbill" align="center" border :data="tableData">
				<vxe-column type="checkbox" width="60"></vxe-column>
				<vxe-column field="fbil_code" title="单据编码"></vxe-column>
				<vxe-column field="fbil_sum" title="金额"></vxe-column>
				<vxe-column field="fbil_discount" title="优惠"></vxe-column>
				<vxe-column field="fbil_need" title="应付金额">
					<template #default="{ row }">
						{{row.fbil_sum - row.fbil_discount}}
					</template>
				</vxe-column>
			</vxe-table>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
			<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return {}
				}
			},
			taskid: {
				default: () => {
					return null
				}
			},
			fApi: {
				default: () => {
					return null
				}
			},
			handle: {
				default: () => {
					return null
				}
			},
			type:{
				default: () => {
					return 'FKD'
				}
			}
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				data: [],
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				this.loading = true
				let supplierid = this.fApi.getValue('wlnid')
				let suppliername = this.fApi.getValue('name')
				this.$api.reconciliation.getFinBill({
					type:this.type,
					taskid: this.taskid,
					supplierid: supplierid,
					suppliername: suppliername,
				}).then((res) => {
					this.tableData = res
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.activeName = this.device == 'pc' ? 'track' : 0
				this.$emit('hide')
			},
			show() {
				this.activeName = 'track'
				this.init()
			},
			showPhone() {
				this.activeName = 0
				this.handleClickPhone(this.activeName)
			},
			modalShow() {
				this.modal = true
			},
			submit() {
				let data = []
				let checkdata = this.$refs.wlnfillbill.getCheckboxRecords()
				checkdata.forEach((item) => {
					let obj = {}
					obj.paymentcode = item.fbil_code
					obj.paymentamount = item.fbil_sum
					obj.paymenttype = 8819
					obj.preferential = item.fbil_discount
					obj.needamount = item.fbil_sum - item.fbil_discount
					obj.checkstaffid = this.$store.state.system.user.id
					data.push(obj)
				})
				if(this.type=='FKD'){
					this.handle.obj = data
					this.handle.next()				
				}else{
					this.$emit('submit',{data:data})
				}
				this.cancel()
			}
		},
		components: {

		}
	}
</script>